import { memo, useEffect, useReducer } from "react"
import { initial_toast, toastReducer } from "./reducer"
import ToastContext from "./context"
import { StateProp } from "../types"
import { removeToast } from "./actions"

const ToastState = memo(({ children }: StateProp) => {
  const [toast, dispatch] = useReducer(toastReducer, initial_toast)

  useEffect(() => {
    toast.toasts.forEach((t, index) => {
      setTimeout(() => {
        dispatch(removeToast(index))
      }, t.time ?? 5000)
    })
  }, [toast.toasts])

  return (
    <ToastContext.Provider value={{ toast, dispatch }}>
      {children}
    </ToastContext.Provider>
  )
})

export default ToastState
